$(document).ready(function(){
    
  // Build a Box small print
  
  $("#bxp-bldr-price_total").append("<div class='bbsmallprint discountsmallprint'>Discount automatically applied at check out.</div> ");
  $("#bxp-bldr-bottom-wizard").append("<div class='bbsmallprint'>* Once you click <b>COMPLETE ORDER</b> and go to the cart, you will not be able to modify your bundle.</div> ");

  $(".bxp-details-price").text(function(index, text) { 
    return text.replace(':', ' '); 
  });

  $("body").on('DOMSubtreeModified', "#bxp-bldr-total_value", function() {
      setTimeout(function(){  
        $(".bxp-details-price").text(function(index, text) { 
        return text.replace(':', ' '); 
        });
      }, 500);
  });

  // $("body").on('DOMSubtreeModified', ".bxp-bldr-item", function() {
  //  setTimeout(function(){  
  //    $(".bxp-bldr-item strong").text(function(index, text) { 
  //    return text.replace(' - 1 box (16 tea bags)', ' '); 
  //    });
  //  }, 500);
  // });

});